import { render, staticRenderFns } from "./LearningCenter.vue?vue&type=template&id=81979bc8&scoped=true&"
import script from "./LearningCenter.vue?vue&type=script&lang=js&"
export * from "./LearningCenter.vue?vue&type=script&lang=js&"
import style0 from "./LearningCenter.vue?vue&type=style&index=0&id=81979bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81979bc8",
  null
  
)

export default component.exports